import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { showMessage } from '../../actions/show-message';
import RootBase from '../root-base';
import { createNavigation } from '../../services/create-navigation';
import getRoutes from '../../get-routes';

const Root = ({ store, history, i18n }) => {
  const actions = bindActionCreators({ showMessage }, store.dispatch);
  const navigation = createNavigation(store);
  return (
    <RootBase
      store={store}
      history={history}
      i18n={i18n}
      environment={{ navigation, showMessage: actions.showMessage }}
    >
      {getRoutes()}
    </RootBase>
  );
};

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
};

export default Root;
